import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowDown, faArrowUp, faCircleXmark, faCircleCheck, faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(timezone);

@Component({
  selector: 'app-generic-table',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule],
  templateUrl: './generic-table.component.html',
  styleUrl: './generic-table.component.scss'
})
export class GenericTableComponent {
  @Input() columnsHeader: any = [];
  @Input() dataTable: any = [];

  @Output() onSelectRow: any = new EventEmitter();
  @Output() onDeleteItem: any = new EventEmitter();

  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faActiveCheck = faCircleCheck;
  faCloseCheck = faCircleXmark;
  iconDelete = faTrashCan;
  dataTableWithoutSort: any;
  isModalDeleteConfirm = false;
  itemToDelete: any;
  isInKBZ = false;

  constructor(
    // public authService: AuthService
  ){}

  ngOnInit(): void {
    this.dataTableWithoutSort = [...this.dataTable];
  }

  ngOnChanges(changes: any) {
    this.dataTableWithoutSort = [...changes?.dataTable?.currentValue];
  }

  selectRow(item: any, column: any) {
    if (!column.isColumnDelete) {
      this.onSelectRow.emit(item);
    } else {
      this.isInKBZ = (column.isViewApo && item.cargado_kanbanize && ['no iniciada'].includes(item.columnKanban.toLowerCase()));
      if (!column.isViewApo || (column.isViewApo && !item.cargado_kanbanize) || this.isInKBZ) {
        this.itemToDelete = item;
        this.isModalDeleteConfirm = true;
      }
    }
  }

  delete() {
    this.onDeleteItem.emit(this.itemToDelete);
    this.isModalDeleteConfirm = false;
  }

  sortColumns(column: any) {
    if (column.isSorteable) {
      this.initSorts(column);
      if (column.sort === '') {
        column.sort = 'up';
        this.dataTable.sort((a: any, b: any) => a[column.key].localeCompare(b[column.key]) || new Date(a['fecha_inicio']).getTime() - new Date(b['fecha_inicio']).getTime());
      } else if (column.sort === 'up') {
        column.sort = 'down';
        this.dataTable.sort((a: any, b: any) => b[column.key].localeCompare(a[column.key]) || new Date(a['fecha_inicio']).getTime() - new Date(b['fecha_inicio']).getTime()); 
      } else if (column.sort === 'down') {
        column.sort = '';
        this.dataTable = [...this.dataTableWithoutSort];
      }
    }
  }

  private initSorts(columnToSort: any) {
    this.columnsHeader.filter((column: any) => column.key !== columnToSort.key).map((column: any) => column.sort = '');
  }

  getNumberColumns() {
    return this.columnsHeader.length;
  }

  getDateWithFormat(date: any) {
    const dateFormat = dayjs(date).utc().format('DD/MM/YYYY HH:mm');
    return dateFormat;
  }

}
